import React, { PropsWithChildren } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import SectionLabel from '../../shared/SectionLabel';

export default function RateSection({ children, hint, label }: PropsWithChildren<{ hint?: string; label: string }>) {
  return (
    <Box>
      <SectionLabel>{label}</SectionLabel>
      <Stack alignItems="center" direction="row" spacing={1}>
        {children}
      </Stack>
      {hint && (
        <Typography color="text.secondary" sx={{ display: 'block', mt: 0.5 }} variant="caption">
          {hint}
        </Typography>
      )}
    </Box>
  );
}
